import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import TextBlock from "@/components/TextBlock/TextBlock";
import type { ShareClassDashboard } from "@/services/server/v1/getShareClassDashboard";
import { htmlify } from "@/services/utils";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export const FxTextPanel = ({ dashboard, flex, config }: FundDetailLayoutComponentProps) => {
	const type = config?.textId ? config.textId : config?.type;
	if (!type) {
		return null;
	}

	const props = dashboard[`fxTextPanel_${type}` as keyof ShareClassDashboard];

	if (!props) {
		return null;
	}

	const { heading, tooltip, ...remainingProps } = props;

	return (
		<ContentBlock
			id="fxTextPanel"
			data-testid={`fxTextPanel_${type}`}
			flex={flex}
			heading={htmlify(heading)}
			tooltip={htmlify(tooltip)}
		>
			<TextBlock {...remainingProps} numberOfLines={1000} />
		</ContentBlock>
	);
};
